/**
 * The Grader vocabulary (CONTEXT.md): `GRADING_COMPANIES` in `backend/src/trovie/domain/grading.py`,
 * mirrored by hand. Nothing fails when the two drift, so a grader added or retired there must change
 * here too. Manual slab entry and the inventory Grader filter both offer this list; a grader missing
 * here leaves the slabs it graded unfilterable. BCCG and BVG trail because few slabs carry them.
 */
export const GRADERS = [
  "PSA",
  "BGS",
  "CGC",
  "SGC",
  "TAG",
  "PGC",
  "ACE",
  "AGS",
  "DGS",
  "MANA",
  "BCCG",
  "BVG",
] as const;

export type Grader = (typeof GRADERS)[number];

/** The grades a dealer files most, highest first. A half grade the grader does not issue is simply
 *  never picked. */
export const SLAB_GRADES = [
  "10",
  "9.5",
  "9",
  "8.5",
  "8",
  "7.5",
  "7",
  "6.5",
  "6",
  "5",
  "4",
  "3",
  "2",
  "1",
] as const;
